import { render, staticRenderFns } from "./erwImg.vue?vue&type=template&id=57090552&scoped=true&"
import script from "./erwImg.vue?vue&type=script&lang=js&"
export * from "./erwImg.vue?vue&type=script&lang=js&"
import style0 from "./erwImg.vue?vue&type=style&index=0&id=57090552&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57090552",
  null
  
)

export default component.exports